<template lang="pug">
component(
  :is="'src' in props.props ? UcAssetVue : UcParallaxVue"
  v-bind="props.props"
)
</template>

<script setup lang="ts">
import UcAssetVue from './uc-asset.vue';
import UcParallaxVue from './uc-parallax.vue';

const props = defineProps<{ props: UcAsset | UcParallax }>();
</script>
